import DataCard from "components/Common/DataCard"
import { ACCESS } from "constants/accessPermissions"
import { useAuth } from "hooks/authHook"
import { Link } from "react-router-dom"

export default function ImporterDetails({ data = {}, loading = false }) {
  const { hasAnyPermission } = useAuth()
  const accessViewImporter = !hasAnyPermission([ACCESS.STOCK.VIEW_IMPORTER])
  const accessViewImporterDetails = hasAnyPermission([
    ACCESS.VEHICLE_IMPORTER.VIEW_VEHICLE_IMPORTER,
  ])

  const formattedData = [
    ...(!accessViewImporter
      ? [
          {
            label: "Importer",
            value: (
              <Link
                to={
                  accessViewImporterDetails
                    ? `/importer-list/${data?.importer?.slug}/view`
                    : "#"
                }
              >
                {data?.importer?.name ?? "-"}
              </Link>
            ),
          },
        ]
      : []),
    {
      label: "Remarks",
      value: data?.remarks ?? "-",
    },
    {
      label: "Drive Link",
      // open a new tab if link exists, otherwise do nothing
      value: data?.drive_link ? (
        <a href={data.drive_link} target="_blank" rel="noopener noreferrer">
          Google Drive Link
        </a>
      ) : (
        "-"
      ),
    },
  ]

  return (
    <DataCard
      title={
        !accessViewImporter ? `Reference & Comments` : `Importer & Reference`
      }
      icon="bx bx-share-alt"
      data={formattedData}
      action={loading}
    />
  )
}
